// Route stub created by tools/gen_web_routes.py from contract/catalog/screens.json; owned by hand from here on (A4U8):
// the loader warms the public preview and the sign-in probe the screen reads.
import { ids } from '@orca/api-client/testIds'
import { createFileRoute } from '@tanstack/react-router'
import { InvitationAccept } from '../../features/onboarding/InvitationAccept'
import { invitationPreviewQuery, signedInQuery } from '../../features/onboarding/queries'
import { Part } from '../../shared/shell/StatePart'

export const Route = createFileRoute('/invite/$code')({
  staticData: { screenId: 'InvitationAcceptScreen', access: 'valid invitation code; works signed in or out' },
  loader: async ({ context: { queryClient }, params }) => {
    await Promise.all([
      queryClient.ensureQueryData(invitationPreviewQuery(params.code)),
      queryClient.ensureQueryData(signedInQuery()),
    ])
  },
  component: InvitationAcceptScreen,
})

function InvitationAcceptScreen() {
  const { code } = Route.useParams()
  return (
    <Part testId={ids.invitationAccept.skeleton}>
      <InvitationAccept code={code} testId={ids.invitationAccept.root} />
    </Part>
  )
}
